import { render, staticRenderFns } from "./cards-board.vue?vue&type=template&id=c41e8034&scoped=true"
import script from "./cards-board.vue?vue&type=script&lang=js"
export * from "./cards-board.vue?vue&type=script&lang=js"
import style0 from "./cards-board.vue?vue&type=style&index=0&id=c41e8034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41e8034",
  null
  
)

export default component.exports